import { render } from "./ChallengeModal.vue?vue&type=template&id=0b070774&scoped=true"
import script from "./ChallengeModal.vue?vue&type=script&lang=js"
export * from "./ChallengeModal.vue?vue&type=script&lang=js"

import "./ChallengeModal.vue?vue&type=style&index=0&id=0b070774&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b070774"]])

export default __exports__